import React, { } from 'react';
import PropTypes from 'prop-types';

import StatusIndicator from './status-indicator';

const SearchList = ({
	id,
	title,
	interfaceType = null,
	version = null,
	description = null,
	state,
	objectType = 'SPECIFICATION',
	handleCardClick,
}) => {
	const truncateDescription = string => {
		const length = 150;
		if (string.length > length) {
			return `${string.slice(0, length)}...`;
		}
		return string;
	};

	return (
		<div
			className={`search-list is-${objectType.toLowerCase()}`}
			onClick={() => handleCardClick(id)}
			role="presentation"
		>
			<div className="flex-row justify-space-between align-items-flex-start">
				<div>
					<h4 className="display-inline-block margin-right-8 margin-bottom-none">{title}</h4>
					{version && (
						<span className="grey-text">{`V${version}`}</span>
					)}
					{interfaceType && (
						<span className="grey-text margin-left-16">{interfaceType}</span>
					)}
				</div>
				<div className="search-card__status flex-row align-items-center">
					<StatusIndicator state={state} />
				</div>
			</div>
			{description && (
				<p className="search-card__description margin-top-4">
					{truncateDescription(description)}
				</p>
			)}
		</div>
	);
};

export default SearchList;

SearchList.propTypes = {
	id: PropTypes.number.isRequired,
	title: PropTypes.string.isRequired,
	interfaceType: PropTypes.string,
	version: PropTypes.string,
	description: PropTypes.string,
	state: PropTypes.objectOf.isRequired,
	objectType: PropTypes.string,
	handleCardClick: PropTypes.func.isRequired,
};
